/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ShieldIcon = ({ width = 24, height = 24, hidden = false, title = 'Shield' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M30 3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v13.1a15.608 15.608 0 0 0 5.857 12.187l5.674 4.355a.7.7 0 0 0 .937 0l5.674-4.355A15.608 15.608 0 0 0 30 16.1ZM9.722 22.287A14.482 14.482 0 0 1 8 16V4h20Z"
    />
  </svg>`;
};
